export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_LOADING = 'SET_LOADING';
export const SET_LOADED = 'SET_LOADED';
export const SET_BELL_NOTIFICATIONS = 'SET_BELL_NOTIFICATIONS';
export const SET_BELL_LOADING = 'SET_BELL_LOADING';
export const SET_BELL_LOADED = 'SET_BELL_LOADED';
export const SET_COUNT_NEW = 'SET_COUNT_NEW';

